export const environment = {
  version: "1.0",
  host: "https://dev-pcdss.spmed.kr",
  gateway: "https://dev-gwapi.spmed.kr/api-gateway/v1.0",
  spmedLat: 35.25593540888019,
  spmedLong: 129.01287639011213,
  production: false,
};
